// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/foundation_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/foundation.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/accessories_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/accessories.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/walkAround_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/walkAround.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/maintenanceReminder_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/maintenanceReminder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images/fixItRight_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images/fixItRight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images/efficiency_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images/efficiency.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images/dpok_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/images/dpok.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/images/toyota_way_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../assets/images/toyota_way.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../assets/images/customer_centricity_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../assets/images/customer_centricity.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../assets/images/employee_engagement_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../assets/images/employee_engagement.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../assets/images/business_sustainability_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../assets/images/business_sustainability.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionPlanContainer {
    margin-right: 0px !important;
    margin-left: 0px !important;
    margin-top: 1.7rem !important;
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: none !important;
}

.activityDiv {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #F7F7F7;
}

.activityTabsHeader {
    color: black;
}

.activityTabsHeaderRed {
    padding-top: 1rem;
    /* margin-bottom:2rem;  */
}

.nav-tabs>li:first-child>a {
    border-top-left-radius: 1.25rem !important;
}

.nav-tabs>li:last-child>a {
    border-top-right-radius: 1.25rem !important;
}

.selectedCriteria {
    font-weight: bold;
}

.activityTabs {
    /* opacity: 0.9;  */
}

.activityTabs .nav-item {
    width: 18% !important;
}

.activityTabs .tab-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
    width: 100%;
    float: left;
    /*background: rgb(212, 210, 210);*/
}

.activityTabs .nav-tabs {
    opacity: 0.8;
}

.edit-icon-white {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 28px;
    width: 28px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
}

.actionPlanContainer-toyota .foundation_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .foundation_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .accessories_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .accessories_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .walk_around_check_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}

.actionPlanContainer-lexus .walk_around_check_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}

.actionPlanContainer-toyota .maintenance_reminders_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .maintenance_reminders_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .fix_it_right_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .fix_it_right_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .efficiency_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .efficiency_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .dpok_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .dpok_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.FileDownload:hover {
    border-bottom: solid 1px;
    font-size: 1rem;
}

.downloadContainer {
    background: rgba(255, 255, 255, 0.7);
    margin: 2px;
}

.downloadContainer:hover {
    background: rgb(255, 255, 255);
}

.actionPlanContainer-toyota .active {
    border-bottom: #E50000 2px solid !important;
}

.actionPlanContainer-lexus .active {
    border-bottom: #252525 2px solid !important;
}

.activityTabs .nav-link {
    margin-left: 2px !important;
}

.activityTabs .tab-content {
    background-color: #f0f0f0;
}

.activityTabs tbody tr {
    border-bottom: 2px solid #f0f0f0 !important
}

.actionPlanContainer-toyota .toyota_way_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .toyota_way_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .customer_centricity_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .customer_centricity_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .employee_engagement_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .employee_engagement_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .business_sustainability_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .business_sustainability_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota_icon {
    height: 40px;
    width: 40px;
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}

.actionPlanContainer-lexus_icon  {
    height: 40px;
    width: 40px;
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}
.evidenceUploaded {
    display: inline-block;
    background-color: #44aa44;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
}

.evidenceNotUploaded {
    display: none;
}

ul.nav .nav-tabs li.nav-item.nav-link {
    display: inline-block;
    background-color: #44aa44;
    border-radius: 50%;
    margin-bottom: 6px;
    width: 8px;
    height: 8px;
    margin-left: 0.2rem;
}

.tabs.mb_tab ul li > a
 {
    /* display: inline-block;
    background-color: green !important;
    border-radius: 50% !important;
    margin-bottom: 6px !important;
    width: 8px !important;
    height: 8px !important;
    margin-left: 0.2rem !important;
    white-space: nowrap; */
}`, "",{"version":3,"sources":["webpack://./src/components/actionPlan/index.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA6D;IAC7D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAAyD;IACzD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA8D;IAC9D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA0D;IAC1D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA6D;IAC7D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAAyD;IACzD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAAsE;IACtE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAAkE;IAClE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA6D;IAC7D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAyD;IACzD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA6D;IAC7D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAyD;IACzD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAuD;IACvD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAmD;IACnD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA6D;IAC7D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAyD;IACzD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAsE;IACtE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAkE;IAClE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAsE;IACtE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAkE;IAClE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA0E;IAC1E,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAsE;IACtE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI;;;;;;;0BAOsB;AAC1B","sourcesContent":[".actionPlanContainer {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n    margin-top: 1.7rem !important;\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: none !important;\n}\n\n.activityDiv {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-color: #F7F7F7;\n}\n\n.activityTabsHeader {\n    color: black;\n}\n\n.activityTabsHeaderRed {\n    padding-top: 1rem;\n    /* margin-bottom:2rem;  */\n}\n\n.nav-tabs>li:first-child>a {\n    border-top-left-radius: 1.25rem !important;\n}\n\n.nav-tabs>li:last-child>a {\n    border-top-right-radius: 1.25rem !important;\n}\n\n.selectedCriteria {\n    font-weight: bold;\n}\n\n.activityTabs {\n    /* opacity: 0.9;  */\n}\n\n.activityTabs .nav-item {\n    width: 18% !important;\n}\n\n.activityTabs .tab-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n    width: 100%;\n    float: left;\n    /*background: rgb(212, 210, 210);*/\n}\n\n.activityTabs .nav-tabs {\n    opacity: 0.8;\n}\n\n.edit-icon-white {\n    background-image: url(\"../../assets/images/edit.png\");\n    height: 28px;\n    width: 28px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n}\n\n.actionPlanContainer-toyota .foundation_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/foundation_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .foundation_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/foundation.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .accessories_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/accessories_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .accessories_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/accessories.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .walk_around_check_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/walkAround_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n\n.actionPlanContainer-lexus .walk_around_check_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/walkAround.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n\n.actionPlanContainer-toyota .maintenance_reminders_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/maintenanceReminder_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .maintenance_reminders_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/maintenanceReminder.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .fix_it_right_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/fixItRight_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .fix_it_right_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/fixItRight.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .efficiency_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/efficiency_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .efficiency_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/efficiency.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .dpok_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/dpok_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .dpok_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/dpok.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.FileDownload:hover {\n    border-bottom: solid 1px;\n    font-size: 1rem;\n}\n\n.downloadContainer {\n    background: rgba(255, 255, 255, 0.7);\n    margin: 2px;\n}\n\n.downloadContainer:hover {\n    background: rgb(255, 255, 255);\n}\n\n.actionPlanContainer-toyota .active {\n    border-bottom: #E50000 2px solid !important;\n}\n\n.actionPlanContainer-lexus .active {\n    border-bottom: #252525 2px solid !important;\n}\n\n.activityTabs .nav-link {\n    margin-left: 2px !important;\n}\n\n.activityTabs .tab-content {\n    background-color: #f0f0f0;\n}\n\n.activityTabs tbody tr {\n    border-bottom: 2px solid #f0f0f0 !important\n}\n\n.actionPlanContainer-toyota .toyota_way_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/toyota_way_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .toyota_way_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/toyota_way.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .customer_centricity_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/customer_centricity_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .customer_centricity_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/customer_centricity.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .employee_engagement_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/employee_engagement_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .employee_engagement_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/employee_engagement.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .business_sustainability_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/business_sustainability_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .business_sustainability_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images/business_sustainability.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota_icon {\n    height: 40px;\n    width: 40px;\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n\n.actionPlanContainer-lexus_icon  {\n    height: 40px;\n    width: 40px;\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n.evidenceUploaded {\n    display: inline-block;\n    background-color: #44aa44;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n}\n\n.evidenceNotUploaded {\n    display: none;\n}\n\nul.nav .nav-tabs li.nav-item.nav-link {\n    display: inline-block;\n    background-color: #44aa44;\n    border-radius: 50%;\n    margin-bottom: 6px;\n    width: 8px;\n    height: 8px;\n    margin-left: 0.2rem;\n}\n\n.tabs.mb_tab ul li > a\n {\n    /* display: inline-block;\n    background-color: green !important;\n    border-radius: 50% !important;\n    margin-bottom: 6px !important;\n    width: 8px !important;\n    height: 8px !important;\n    margin-left: 0.2rem !important;\n    white-space: nowrap; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
